module.exports = __webpack_public_path__ + "f3ecaab1d1cfb23b4677acbc8f3d0a3a.png";